<template>
  <div class="confirm-message">
    <div class="message-success">
      {{ text }}
    </div>

    <div class="confirm-message__actions">
      <button
        v-if="showCancel"
        type="button"
        class="btn btn-primary"
        :disabled="cancelDisabled"
        @click="$emit('cancel')"
      >
        {{ cancelText }}
      </button>
      <button
        v-if="showOk"
        type="button"
        class="btn btn-primary"
        :disabled="okDisabled"
        @click="$emit('ok')"
      >
        {{ okText }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmMessage',
  props: {
    text: { type: String, default: '' },
    okText: { type: String, default: 'Ok' },
    cancelText: { type: String, default: 'Cancel' },
    okDisabled: { type: Boolean, default: false },
    cancelDisabled: { type: Boolean, default: false },
    showOk: { type: Boolean, default: true },
    showCancel: { type: Boolean, default: true },
  },
};
</script>

<style scoped>
.confirm-message {
  text-align: center;
}

.confirm-message__actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 14px;
}
</style>
